module.exports = __webpack_public_path__ + "img/72.7ec56d55.jpg";